var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgImportDocument = function SvgImportDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.001 1.998a1.993 1.993 0 0 0-1.992 2L3.999 20c0 1.104.889 1.998 1.992 1.998h12.006A2.001 2.001 0 0 0 20 20V7.998l-6.001-6m-1.002 1.498 5.504 5.503h-5.504m3.004 2.93V19H8.93l2.12-2.123-2.828-2.827 2.828-2.828 2.826 2.828"
  })));
};

export default SvgImportDocument;